import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import { EntWebsiteDomainProvider } from 'bundles/ent-website/components/EntWebsiteDomainContext';
import { EntWebsiteNavDomainDataProvider } from 'bundles/ent-website/components/EntWebsiteNavDomainContext';
import EntWebsitePage from 'bundles/ent-website/components/EntWebsitePage';
import GoogleSiteValidation from 'bundles/ent-website/components/head/GoogleSiteValidation';
import MutinyTag from 'bundles/ent-website/components/head/MutinyTag';
import type { DOMAINS } from 'bundles/ent-website/constants/navigation';
import formatPathname from 'bundles/ent-website/utils/formatPathname';

type Props = {
  domain: keyof typeof DOMAINS;
  slugOverride?: string;
};

const MUTINY_SUPPORTED_DOMAINS: string[] = ['c4b', 'c4c', 'c4g', 'c4t', 'dev', 'enterprise'];

function EntWebsitePageWrapper({ domain, slugOverride }: Props) {
  const router = useRouter();
  const domainOverride = router.location.query.domainOverride as keyof typeof DOMAINS;

  let slug: string;

  if (slugOverride) {
    slug = slugOverride;
  } else {
    /**
     * Hack start here :(
     * demand base form enrichment creates an invalid url with first
     * query param starting with & instead of ?
     */
    let pathname = router.location.pathname;
    const invalidAmpIdx = pathname.indexOf('&');
    if (invalidAmpIdx !== -1) {
      pathname = pathname.slice(0, invalidAmpIdx);
    }
    slug = formatPathname(pathname);
  }

  return (
    <EntWebsiteDomainProvider domain={domainOverride ?? domain}>
      {MUTINY_SUPPORTED_DOMAINS.includes(domain) && <MutinyTag />}
      <GoogleSiteValidation pathname={router.location.pathname} />
      <EntWebsiteNavDomainDataProvider slug={slug}>
        <EntWebsitePage slug={slug} />
      </EntWebsiteNavDomainDataProvider>
    </EntWebsiteDomainProvider>
  );
}

export default EntWebsitePageWrapper;
